import React, { useState, useEffect, useMemo } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';
import { Modal, OverlayTrigger ,Tooltip} from 'react-bootstrap';
import './Tablenav.css';
import Thousand from './filters/Thousand';
import Thousandone from './filters/Thousandone';
import Thousandtwo from './filters/Thousandtwo';
import Thousandthree from './filters/Thousandthree';
import Thousandfour from '../../components/Filtermodal/filters/Thousandfour';
import ExcelIcon from '../../assets/excel.png';
import { RxCross2 } from 'react-icons/rx';
import { IoFilter } from "react-icons/io5";
import { FaPrint } from "react-icons/fa";
import { downloadTable } from '../../utility/excelprint/downloadTable';
import { printpdfFun } from '../../utility/excelprint/printpdfFun';
import { useLocation, useNavigate } from 'react-router';
import { dropCacheById } from '../../utility/aliveController';

const Tablenav = (props) => {
  const location=useLocation()
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [filtername, setFiltername] = useState('');
  const [defaultValue, setDefaultValue] = useState([]);
  const [UpdateddefaultValue, setUpdateddefaultValue] = useState([]);
  const [UnsetdefaultValue, setUnsetdefaultValue] = useState([]);
  const [lastChange, setLastChange] = useState(null);
  const[filtercount,setfiltercount]=useState(0)
  const [searchTerm,setSearchitem]=useState("")
  const navigate=useNavigate()
const checkfiltervalues = (filtercountlist) => {
  console.log(filtercountlist,"filter")
  let filtercountdata = 0;
  const deffilter = filtercountlist?.def;

  for (let key in deffilter) {
    const current = deffilter[key];
    if (key === "Due Date" && current === "Any") continue;
    if (Array.isArray(current) && current.length > 0) {
      filtercountdata++;
    }
    else if (typeof current === "string" && current.trim() !== "") {
      filtercountdata++;
    }
    else if (typeof current === "number" && current !== 0) {
      filtercountdata++;
    }
  }
  console.log(filtercountdata,"filtercountdata")
  setfiltercount(filtercountdata)
};
  useEffect(() => {
    const obj = { values: {}, def: {}, oldValues: {} };
    if (props.filters !== undefined && props.filters !== null) {
      props.filters.forEach((filter) => {
        obj.values[filter.filtername] = filter.values;
        obj.def[filter.filtername] = filter.defval;
        obj.oldValues[filter.filtername] = filter.defval;
      });
      setDefaultValue([obj]);
      setUpdateddefaultValue([obj]);
      setUnsetdefaultValue([obj]);
      checkfiltervalues(obj)
    }
  }, [props.filters]);

  const clearFilters = (e) => {
    e.preventDefault();
    defaultValue[0].def = { ...defaultValue[0].oldValues };
    props.clearFilters(-1);
    setIsOpenModal(false);
  };

  const updateDefaultValues = (data) => {
    const defaultdata = JSON.parse(JSON.stringify(UpdateddefaultValue));
    defaultdata[0].def[filtername] = data;
    setUpdateddefaultValue(defaultdata);
  };

  const updateDefaultCheckboxValues = (data, lastchange) => {
    setLastChange(lastchange);
    const defaultdata = JSON.parse(JSON.stringify(UpdateddefaultValue));
    defaultdata[0].def[filtername] = data;
    setUpdateddefaultValue(defaultdata);
  };

  const applyFilters = (e) => {
    e.preventDefault();
    if (Object.keys(UpdateddefaultValue[0].def).length !== 0) {
      setDefaultValue(UpdateddefaultValue);
      checkfiltervalues(UpdateddefaultValue[0])
      console.log(UpdateddefaultValue,"UpdateddefaultValue")
      setIsOpenModal(false);
      setTimeout(() => {
        let filterStr = '';
        const keys = Object.keys(UpdateddefaultValue[0].def);
        keys.forEach((key, i) => {
          filterStr += UpdateddefaultValue[0].def[key] + (i < keys.length - 1 ? '$#12$$' : '');
        });
        props.getResultFromFilter(filterStr);
      }, 200);
    }
  };

  const setsearchblankhandle=()=>{
    setSearchitem("")
  }

  const openFilterModal = (e) => {
    e.preventDefault();
    setIsOpenModal(true);
    if (props.filters !== null) {
      setFilterData(props.filters[0]);
      setFiltername(props.filters[0].filtername);
    }
  };

  const closeFilterModal = () => {
    setIsOpenModal(false);
    setUpdateddefaultValue(defaultValue);
  };
const keepAliveId = useMemo(() => {
  return `dynamicreport-${location.key}`;
}, []); 
  return (
    <>
      <nav className="navbar navbar-light bg-light" style={{ marginTop: !props.hide ? "0px":"5px" }}>
      {!props.hide && <div className="justify-content-end ms-3">
          <IconButton onClick={()=>{
dropCacheById(keepAliveId);
            setTimeout(() => {
              navigate(-1)
            }, 100);
          }} >
         <ArrowBackIcon   />
          </IconButton>
          <span style={{ fontSize: "23px", fontWeight: "600", paddingLeft: "20px", position: "relative", top: "5px" }}>{props.header}</span>
        </div>}


       {props?.hide && <div>
        <span style={{ fontSize: "23px", fontWeight: "600", paddingLeft: "7px", position: "relative", top: "5px" }}>{props.header}</span>
        </div>}
        <div className="justify-content-center">

          {props?.filters !== null &&

              <IconButton onClick={openFilterModal}> 
                 
  <IoFilter   />
  {filtercount > 0 && (
    <span className="filter-applied-count">
      {filtercount}
    </span>
  )}

              </IconButton>
          }
          { props.disableexcel &&
            <IconButton onClick={(e) => downloadTable(props.drillPathDataMap,props.header,props.levelwisehead)} >
            <img src={ExcelIcon} style={{ width: "25px", height: "25px" }}  />
          </IconButton>
          }
         {
          props.disableexcel &&
          <IconButton onClick={(e) => printpdfFun(props.drillPathDataMap,props.header,props.levelwisehead)} >
              <FaPrint   />
          </IconButton>
         }

        </div>
      </nav>

      {props.filters !== undefined && props.filters !== null && (
       <Modal size="lg" centered style={{ backgroundColor: 'rgba(0,0,0,0.6)' , boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }} show={isOpenModal} onHide={closeFilterModal}>
       <Modal.Header style={{paddingBottom:"8px",paddingTop:"8px", backgroundColor:"#29b6f6" , color:"white" , display:"flex", justifyContent:"space-between", alignItems:"center"}}>
         <h3 style={{marginBottom:"0px"}}>
         <IoFilter color='white' style={{marginBottom:"5px"}} />
         &nbsp;
          Filters
         </h3>
         <div style={{ display: "flex", justifyContent: "space-between", width: "auto" }}>
           <div style={{ color: "black", fontSize: 'x-large', cursor: 'pointer', right: '0px' }} onClick={closeFilterModal}>

           <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="close-tooltip">close filter</Tooltip>}
          >
             <RxCross2 style={{color:"white"}} />
             </OverlayTrigger>
           </div>
         </div>
       </Modal.Header>


       <Modal.Body style={{ paddingBottom: '0px', paddingTop: '0px', display: "flex", flexDirection: "column" }}>
         <div className="row" style={{ marginBottom: '0px', position: "relative", flexGrow: 1 }}>
           <div className="col-4" style={{
             backgroundColor: '#eceff1',
             marginLeft: '-4px',
           }}>
             <div className='row filternames' style={{ padding: '0px' }}>
               {props.filters.map((data, index) => {
                 const defVal = UpdateddefaultValue?.[0]?.def?.[data.filtername];

    let count = 0;
    if (Array.isArray(defVal)) {
      count = defVal.length;
    } else if (typeof defVal === "string" && defVal.trim() !== "") {
      count = defVal.split(",").filter(v => v.trim() !== "").length;
    }

    const hideCount = data.filtername === "Due Date" && (defVal === "Any" || defVal?.trim() === "Any");
                return (

                         <div key={index}
                   className={'col-12 d-flex justify-content-between align-items-center' + (data.filtername === filtername ? " active" : ' non-active')}
                   onClick={() => {
                     setFilterData(data);
                     setFiltername(data.filtername);
                     setSearchitem("")
                   }}>
                   {data.filtername}
                     {!hideCount && count > 0 && (
          <span style={{color: "#29b6f6" }}>
            {count}
          </span>
        )}
                 </div>
                )
               }
               )}
             </div>
           </div>

           <div className="col-8" style={{ maxHeight:"400px", overflow:"hidden", padding: "12px 10px" }}>
             <div >
               {filterData && (
                 filterData.filtertype === 1000 ? <Thousand defdata={UpdateddefaultValue[0].def[filterData.filtername]} onChange={updateDefaultValues} /> :
                 filterData.filtertype === 1001 ? <Thousandone defdata={UpdateddefaultValue[0].def[filterData.filtername]} onChange={updateDefaultValues} /> :
                 filterData.filtertype === 1002 ? <Thousandtwo filterData={UpdateddefaultValue[0].values[filterData.filtername]} defdata={UpdateddefaultValue[0].def[filterData.filtername]} onChange={updateDefaultValues}  setsearchblankhandle={()=>setsearchblankhandle}  /> :
                 filterData.filtertype === 1003 ? <Thousandthree filterData={UpdateddefaultValue[0].values[filterData.filtername]} defdata={UpdateddefaultValue[0].def[filterData.filtername]} onChange={updateDefaultCheckboxValues} lastChange={lastChange} searchTerm={searchTerm}  /> :
                 filterData.filtertype === 1004 ? <Thousandfour filterData={UpdateddefaultValue[0].values[filterData.filtername]} defdata={UpdateddefaultValue[0].def[filterData.filtername]} onChange={updateDefaultValues} /> : ""
               )}
             </div>
           </div>

         </div>
       </Modal.Body>

       <Modal.Footer style={{ display:"flex",  justifyContent: "flex-end" , gap:"10px"}}>
         <div className="bbtndanger" style={{ color: "#fff", fontSize: '17px' }} onClick={clearFilters}>Clear Filters</div>
         <div className="bbtninfo" style={{ color: "#fff", fontSize: '17px' }} onClick={applyFilters}>Apply</div>
       </Modal.Footer>

     </Modal>

      )}
    </>
  );
};

export default Tablenav;